// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2y9Nu","actionsCol":"EnrolledClinics_actionsCol__1s477"};